import React, { useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import "../../css/Carousel.css";
import { showPrice } from "../../utils/showPrice";
import Wishlisted from "../property/Wishlisted";
import dummyImg from "../../images/no-image-thumb.jpg";
import { Link } from "react-router-dom";
import generateSlug from "../common/generateSlug";
import AlertModal from "../modals/AlertModal";
const PremiumProjects = ({
  premiumProjects,
  user,
  token,
  wishlist,
  handleDispatch,
  category,
  title = "Explore our Premium Projects in Jaipur",
}) => {
  const [showAlertModal, setShowAlertModal] = useState(false);
  const handleOpenModal = () => {
    setShowAlertModal(true);

    // Auto close after 2 seconds
    setTimeout(() => {
      setShowAlertModal(false);
    }, 1500);
  };

  const premRef = useRef(null);
  // Premium Projects
  const premiumpro = {
    dots: false,
    infinite: false,
    speed: 1000,
    autoplay: false,
    pauseOnHover: true,
    slidesToShow: 3,

    arrows: null,
    initialSlide: 0,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,

          dots: true,
          arrows: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
          dots: true,
          arrows: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: false,
        },
      },
    ],
  };

  const handlePrevClick2 = () => {
    if (premRef.current) {
      premRef.current.slickPrev();
    }
  };
  const handleNextClick2 = () => {
    if (premRef.current) {
      premRef.current.slickNext();
    }
  };

  const handleLinkClick = (project) => {
    const url = generateSlug(project);
    const propertyIds = project?.property_ids;
    localStorage.setItem(
      "last-property-seen",
      JSON.stringify({ id: propertyIds, typeWithId: url })
    );
    window.location.href = url; // Navigate manually
  };

  const premium = {
    buy: {
      link: "/buy/searches/flats-for-sale-in-jaipur-rajasthan-srcid-1",
      localStorageKey: "selectedItems:Price Desc",
    },
    commercial: {
      link: "/commercial/buy/searches/commerical-property-for-sale-in-jaipur-rajasthan-srcid-1",
    },
    plot: {
      link: "/buy/searches/plots-for-sale-in-jaipur-rajasthan-srcid-1",
      localStorageKey: "selectedItems:Price Desc",
      localStorageFeatures: "property_type:plot",
    },
  };
  const premiumStyles = premium[category];
  //alert(JSON.stringify(premiumProjects))
  return (
    <>
      {premiumProjects?.length > 0 && (
        <section className="afford-section sectiontopgap">
          <div className="container">
            <div className="sectiontitle">
              <div className="titleunderline" data-aos="fade-right">
                <svg
                  width="64"
                  height="3"
                  viewBox="0 0 64 3"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2 1.5H62"
                    stroke="#F68633"
                    stroke-width="3"
                    stroke-linecap="round"
                  />
                </svg>
              </div>
              <h1>{title}</h1>
            </div>

            <div className="slider-controls">
              <button
                className="slider-btn prev-btn"
                onClick={handlePrevClick2}
              >
                ❮
              </button>
              <Link
                to={premiumStyles.link}
                onClick={() => {
                  if (premiumStyles.localStorageKey) {
                    localStorage.setItem(
                      "sort_clicked",
                      premiumStyles.localStorageKey
                    );
                  }
                  if (premiumStyles.localStorageFeatures) {
                    localStorage.setItem(
                      "feature_clicked",
                      premiumStyles.localStorageFeatures
                    );
                  }
                }}
              >
                <button className="view-all-btn">VIEW ALL</button>
              </Link>
              <button
                className="slider-btn next-btn"
                onClick={handleNextClick2}
              >
                ❯
              </button>
            </div>

            <div className="premium_content content_margin">
              <Slider ref={premRef} {...premiumpro}>
                {premiumProjects?.length > 0 &&
                  premiumProjects?.map((premproject, index) => (
                    <div
                      className="premium-box"
                      key={index}
                      style={{ width: "97%" }}
                    >
                      <div className="premium-slides">
                        <div
                          className="primimgbox"
                          style={{
                            backgroundImage: `url(${
                              premproject?.images?.[0] || dummyImg
                            })`,
                          }}
                        >
                          <div className="prim-share">
                            <Wishlisted
                              data={premproject}
                              wishlist={wishlist}
                              user={user}
                              token={token}
                              handleDispatch={handleDispatch}
                              handleOpenModal={handleOpenModal}
                            />

                            {/* <div className="primoclor overlay"></div> */}
                          </div>

                          {/* <img src={premproject.images?.[0]} onError={(e) => { e.target.onerror = null; e.target.src = noImage; }} /> */}
                        </div>

                        {/* <div className="primimgbox">
                  <img src={premproject.images?.[0]} onError={(e) => { e.target.onerror = null; e.target.src = noImage; }} />

                </div> */}
                        <div className="primdata">
                          <div className="protop">
                            <div className="premiumTop">
                              <div className="protitle">
                                <h4>{premproject?.project_name}</h4>
                              </div>
                              <div className="proprice">
                                {/* <Link to="/">
                          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M10.3746 3.66666C10.3746 2.1939 11.5932 1 13.0964 1C14.5996 1 15.8182 2.1939 15.8182 3.66666C15.8182 5.13942 14.5996 6.33334 13.0964 6.33334C12.3374 6.33334 11.6514 6.02877 11.1583 5.53878L7.39047 8.0636C7.42526 8.234 7.44355 8.41 7.44355 8.58976C7.44355 8.94576 7.37202 9.28608 7.24245 9.59712L11.3738 12.2686C11.8428 11.8929 12.4427 11.6666 13.0964 11.6666C14.5996 11.6666 15.8182 12.8606 15.8182 14.3334C15.8182 15.8061 14.5996 17 13.0964 17C11.5932 17 10.3746 15.8061 10.3746 14.3334C10.3746 13.9476 10.4585 13.5804 10.6093 13.2489L6.51129 10.599C6.03325 11.0078 5.40708 11.2564 4.72176 11.2564C3.21858 11.2564 2 10.0625 2 8.58976C2 7.11698 3.21858 5.92308 4.72176 5.92308C5.58614 5.92308 6.3556 6.3178 6.8538 6.93214L10.5054 4.48514C10.4205 4.22687 10.3746 3.95168 10.3746 3.66666Z" fill="#1B4E9B" />
                          </svg>
                        </Link>
                        <Link to="/">
                          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9.465 15.6077C9.21 15.6977 8.79 15.6977 8.535 15.6077C6.36 14.8652 1.5 11.7677 1.5 6.51769C1.5 4.20019 3.3675 2.3252 5.67 2.3252C7.035 2.3252 8.2425 2.9852 9 4.0052C9.38533 3.4846 9.88723 3.06149 10.4655 2.76975C11.0438 2.47802 11.6823 2.32576 12.33 2.3252C14.6325 2.3252 16.5 4.20019 16.5 6.51769C16.5 11.7677 11.64 14.8652 9.465 15.6077Z" stroke="#1B4E9B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                        </Link> */}

                                {/* <Wishlisted  data={premproject} wishlist={wishlist} user={user} token={token} handleDispatch={handleDispatch}/> */}
                              </div>
                            </div>
                          </div>

                          <div className="primmid">
                            <p className="primloc">
                              <svg
                                width="8"
                                height="14"
                                viewBox="0 0 8 14"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M4 0.888672C1.77778 0.888672 0 2.66645 0 4.88867C0 7.11089 4 13.3331 4 13.3331C4 13.3331 8 7.11089 8 4.88867C8 2.66645 6.22222 0.888672 4 0.888672ZM4 6.66645C3.02222 6.66645 2.22222 5.86645 2.22222 4.88867C2.22222 3.91089 3.02222 3.11089 4 3.11089C4.97778 3.11089 5.77778 3.91089 5.77778 4.88867C5.77778 5.86645 4.97778 6.66645 4 6.66645Z"
                                  fill="#F68633"
                                />
                              </svg>
                              <span>
                                {premproject?.sub_locality_name},{" "}
                                {premproject?.locality_name}
                              </span>
                            </p>

                            <ul className="proul">
                              {premproject?.types &&
                                premproject?.types.length > 0 && (
                                  <li>
                                    {premproject?.types
                                      ?.filter((value) => value !== "")
                                      ?.map((value) =>
                                        value.toString().slice(0, 8)
                                      )
                                      .join(", ")}{" "}
                                    {[
                                      "apartment",
                                      "villa",
                                      "independent_house",
                                    ].includes(premproject?.property_type)
                                      ? `BHK ${premproject?.property_type.replace(
                                          /_/g,
                                          " "
                                        )}`
                                      : premproject?.property_type?.replace(
                                          /_/g,
                                          " "
                                        )}
                                  </li>
                                )}
                              {premproject?.sizes &&
                                premproject?.sizes.length > 0 && (
                                  <li>
                                    {premproject?.sizes.length === 1
                                      ? `${premproject.sizes[0]} SQ.FT (${
                                          premproject?.property_type == "plot"
                                            ? "Plot Area"
                                            : "Build Up"
                                        })`
                                      : `${premproject.sizes[0]} - ${
                                          premproject.sizes[
                                            premproject.sizes.length - 1
                                          ]
                                        } SQ.FT (${
                                          premproject?.property_type == "plot"
                                            ? "Plot Area"
                                            : "Build Up"
                                        })`}
                                  </li>
                                )}

                              {premproject?.amenities &&
                                premproject.amenities.length > 0 &&
                                premproject.amenities
                                  .slice(0, 2)
                                  .map((amenity, index) => (
                                    <li key={index}>{amenity.name}</li>
                                  ))}
                            </ul>
                          </div>
                        </div>
                      </div>

                      <div className="premiumBottom">
                        <div className="protitle">
                          <h4>
                            {/* <i className="fa fa-rupee"></i> */}
                            {showPrice(premproject.property_price)}
                          </h4>
                        </div>
                        <div
                          onClick={() => handleLinkClick(premproject)}
                          className="details"
                        >
                          <button className="btn" type="button">
                            <span>Explore</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
              </Slider>
            </div>
          </div>
          {showAlertModal && <AlertModal />}
        </section>
      )}
    </>
  );
};

export default PremiumProjects;
